import { render, staticRenderFns } from "./LocumBookingRequests.vue?vue&type=template&id=41fa417a&"
import script from "./LocumBookingRequests.vue?vue&type=script&lang=js&"
export * from "./LocumBookingRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports